module.exports = __webpack_public_path__ + "28b67065/img/dollar-icon.35c9d638.svg";